module.exports = __webpack_public_path__ + "static/media/SS.49471e3c.svg";